import { motion } from "framer-motion";
import { Droplet, TriangleAlert, EyeOff } from "lucide-react";

const CARDS = [
  { icon: Droplet, title: "Leaks", body: "& water damage" },
  { icon: TriangleAlert, title: "Call-backs", body: "& cost" },
  { icon: EyeOff, title: "Uncertainty", body: "after install" },
];

const reveal = {
  hidden: { opacity: 0, y: 32 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: i * 0.12 },
  }),
};

export default function Problem() {
  return (
    <section id="problem" className="bg-white py-20 sm:py-28 scroll-mt-16" data-testid="problem-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <motion.div variants={reveal} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-80px" }} custom={0}>
            <p className="text-xs font-semibold uppercase tracking-[0.22em] text-slate-500 mb-4" data-testid="problem-eyebrow">
              The Problem
            </p>
            <h2 className="font-display font-extrabold uppercase leading-[1.05] tracking-tight text-4xl sm:text-5xl text-[#0a1f33]">
              Hidden Joints.
              <br />
              Real Risks.
            </h2>
            <span className="block w-12 h-1 bg-[#1c9ce8] mt-6" />
            <p className="mt-7 text-slate-600 leading-relaxed max-w-md" data-testid="problem-body">
              Push-fit connections can end up hidden behind walls, floors and
              ceilings. Once installed, there isn't always an obvious way of knowing
              the connection has been made correctly.
            </p>
            <p className="mt-4 text-slate-600 leading-relaxed max-w-md" data-testid="problem-body-2">
              That uncertainty can mean leaks, water damage, call-backs and cost.
            </p>
          </motion.div>

          <div className="grid sm:grid-cols-3 lg:grid-cols-1 xl:grid-cols-3 gap-4 lg:pt-16">
            {CARDS.map((c, i) => (
              <motion.div
                key={c.title}
                variants={reveal}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, margin: "-60px" }}
                custom={i + 1}
                className="group bg-[#f2f6f9] rounded-2xl px-6 py-10 text-center hover:bg-[#e9f4fc] transition-colors duration-400"
                data-testid={`problem-card-${i + 1}`}
              >
                <c.icon
                  className="w-9 h-9 mx-auto text-[#0a1f33] group-hover:text-[#1c9ce8] transition-colors duration-400"
                  strokeWidth={1.6}
                />
                <p className="mt-5 font-display font-bold text-sm text-[#0a1f33]">{c.title}</p>
                <p className="text-sm text-slate-500 mt-0.5">{c.body}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
